import { message } from 'antd';
import { useEffect, useState } from 'react';

import i18n from 'utils/i18n';

export const useCopied = () => {
	const [isCopied, setIsCopied] = useState(false);

	useEffect(() => {
		if (isCopied) {
			message.success(i18n.t('copiedText') as string, 3);
			setIsCopied(false);
		}
	}, [isCopied]);

	return { setIsCopied };
};
